/**
 * 注册器：把「城郊到城市」这一章的内容挂进原有的三张表。
 *
 * 用法：在 main.js 里 installExpansion()，之后 getItem / getProp / getSeat 都能查到。
 * 重复调用只会注册一次。
 */
import { registerItem, registerProp, registerSeat, PROP_ACTIONS } from './items.js';
import { EXPANSION_ITEMS } from './expansion_items.js';
import {
  VEHICLE_PROPS, JUNK_PROPS, CONTAINER_PROPS, DIRTY_PROPS,
} from './expansion_props.js';
import {
  SHOP_PROPS, CRAFT_PROPS, SHOP_FURNITURE, OUTDOOR_PROPS,
} from './expansion_props_city.js';
import { VEHICLE_BENCH_PROPS } from './vehicle_props.js';
import { PLACE_PROPS } from './place_props.js';
import { installBuildingArt } from '../render/buildings_art.js';

/** 本章新增的交互动作（actions.js 里各有 handler） */
export const EXPANSION_ACTIONS = [
  { id: 'wash', name: '洗衣打理' },
  { id: 'bathe', name: '泡澡净身' },
  { id: 'board', name: '看榜' },
  { id: 'window', name: '衙署办事' },
  { id: 'quest', name: '接委托' },
  { id: 'stall', name: '摊位地皮' },
  { id: 'hire', name: '雇工' },
];

/** 本章新加的可坐之处 */
export const EXPANSION_SEATS = {
  magistrate_seat: { x: 0.5, y: 0.35 },
  long_table: { x: 0.5, y: 0.15 },
  dining_table: { x: 0.5, y: 0.15 },
  changing_bench: { x: 0.5, y: 0.3 },
};

let done = false;

export function installExpansion() {
  if (done) return true;
  done = true;

  for (const [id, def] of Object.entries(EXPANSION_ITEMS)) registerItem(id, def);

  const propGroups = [VEHICLE_PROPS, JUNK_PROPS, CONTAINER_PROPS, DIRTY_PROPS,
    SHOP_PROPS, CRAFT_PROPS, SHOP_FURNITURE, OUTDOOR_PROPS, VEHICLE_BENCH_PROPS,
    PLACE_PROPS];
  for (const group of propGroups) {
    for (const [id, def] of Object.entries(group)) registerProp(id, def);
  }

  for (const [id, def] of Object.entries(EXPANSION_SEATS)) registerSeat(id, def);

  // 房子的画法挂到器物表上（同名重复只是覆盖，无妨）
  installBuildingArt();

  // 器物铸造面板的动作下拉里也要有这几个
  for (const a of EXPANSION_ACTIONS) {
    if (!PROP_ACTIONS.some((x) => x.id === a.id)) PROP_ACTIONS.push(a);
  }
  return true;
}

/** 方便别处按类别取用 */
export const EXPANSION_PROP_GROUPS = {
  VEHICLE_PROPS, JUNK_PROPS, CONTAINER_PROPS, DIRTY_PROPS,
  SHOP_PROPS, CRAFT_PROPS, SHOP_FURNITURE, OUTDOOR_PROPS, VEHICLE_BENCH_PROPS,
};
